const two = (n: number) => String(n).padStart(2, '0');

/** "04-10-2026", or a dash when there is no date. */
export const date = (iso?: string | null): string => {
    if (!iso) {
        return '–';
    }

    const d = new Date(iso);

    return `${two(d.getDate())}-${two(d.getMonth() + 1)}-${d.getFullYear()}`;
};

/** "04-10-2026 09:15": a day alone says too little when a lot happens on one day. */
export const dateTime = (iso?: string | null): string => {
    if (!iso) {
        return '–';
    }

    const d = new Date(iso);

    return `${date(iso)} ${two(d.getHours())}:${two(d.getMinutes())}`;
};

/** "04-10 09:15", for moments within the last days. */
export const moment = (iso?: string | null): string => {
    if (!iso) {
        return '–';
    }

    const d = new Date(iso);

    return `${two(d.getDate())}-${two(d.getMonth() + 1)} ${two(d.getHours())}:${two(d.getMinutes())}`;
};

/** "3 dagen geleden", "vandaag", "2 maanden geleden". */
export const ago = (iso?: string | null, now: Date = new Date()): string => {
    if (!iso) {
        return '';
    }

    const span = age(iso, now);

    return span === 'vandaag' ? 'vandaag' : `${span} geleden`;
};

/** "04-10-2026 (3 dagen geleden)". */
export const dateAgo = (iso?: string | null): string => (iso ? `${date(iso)} (${ago(iso)})` : '–');

/** "3 dagen", "5 weken", "2 maanden": how long something has been open. */
export const age = (iso?: string | null, now: Date = new Date()): string => {
    if (!iso) {
        return '–';
    }

    const days = Math.max(
        0,
        Math.floor((now.getTime() - new Date(iso).getTime()) / 86_400_000)
    );

    if (days < 1) {
        return 'vandaag';
    }

    if (days < 14) {
        return `${days} ${days === 1 ? 'dag' : 'dagen'}`;
    }

    if (days < 61) {
        return `${Math.floor(days / 7)} weken`;
    }

    const months = Math.floor(days / 30);

    return months < 24 ? `${months} maanden` : `${Math.floor(days / 365)} jaar`;
};

/** The key the screen uses for one environment. */
export const environmentKey = (customer: string, environment: string) =>
    `${customer}/${environment}`.toLowerCase();

/** Where the dashboard shows the dossier of one object. */
export const dossierLink = (customer: string, environment: string, id: string) =>
    `/dashboard/${encodeURIComponent(customer)}/${encodeURIComponent(
        environment
    )}?dossier=${encodeURIComponent(id)}`;

/** A day key of the logs, 20261014, as 14-10-2026. */
export const day = (yyyymmdd?: string | null): string =>
    yyyymmdd && yyyymmdd.length === 8 ? `${yyyymmdd.slice(6, 8)}-${yyyymmdd.slice(4, 6)}-${yyyymmdd.slice(0, 4)}` : '–';
